// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_2HMUZ){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_126k9 .flexContainer_2_-Xa{display:flex;align-content:space-between}.nsAddressForm_126k9 .flexContainer_2_-Xa .firstCol_3Diab{margin-right:20px}.nsAddressForm_126k9 .flexContainer_2_-Xa .region_2Zdlr{width:70px}.optional_2UPhk{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_2HMUZ",
	"nsAddressForm": "nsAddressForm_126k9",
	"flexContainer": "flexContainer_2_-Xa",
	"firstCol": "firstCol_3Diab",
	"region": "region_2Zdlr",
	"optional": "optional_2UPhk"
};
module.exports = exports;
